import { NonNullableSubset } from '@upr-web-primer/app-utils';
import { udeploy } from './udeploy';

type IEnvironmentExt = NonNullableSubset<typeof udeploy>;

export const shared_environment: IEnvironmentExt = {
  accountAppPath: '/account',
  adobeAutosearchUrl:
    'https://content.atomz.com/autocomplete/sp10/04/f8/c6/?query=',
  adobeBodyScript:
    'if(_satellite && _satellite.pageBottom) { _satellite.pageBottom();}',
  adobeHeaderScript: '',
  adobeMbox: 'target-global-mbox',
  adobeTargetDisabled: false,
  appTheme: 'white-background',
  baseRedirectBypass: true,
  basic_version: false,
  bingSiteVerificationKey: '695C8D6126AB21D375502ECC658DADD5',
  cardinalScriptUrl:
    'https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js',
  checkSaveTimeProperty: false,
  CHOICE_A_SECTION: '',
  CHOICE_B_SECTION: '',
  DINING_RESERVATION: '',
  commerceApi: 'occ/v2/ukrfr_b2c',
  commerceApiUrl: '',
  commerceClientId: 'mobile_android',
  commerceClientKeyID: 'secret',
  COMPLETE_AP: 'https://apass-p-st.usj.co.jp/app/top.do',
  config: {
    createAccount: {
      // prettier-ignore
      checkboxes: "[{\"tridionKey\":\"createAccount.agree\",\"defaultValue\":false,\"required\":true,\"id\":\"termCondition\",\"altText\":\"createAccount.agreeAltText\"},{\"tridionKey\":\"createAccount.specialOffers\",\"defaultValue\":true,\"required\":false,\"id\":\"specialOffer\",\"altText\":\"createAccount.specialOffersAltText\"}]",
      links:
        '[{"tridionKey":"createAccount.Terms","linkURL":"createAccount.termsLink","target":"_blank","altText":"createAccount.termsAltText"},{"tridionKey":"createAccount.privacyPolicy","linkURL":"createAccount.privacyLink","target":"_blank","altText":"createAccount.privacyPolicyAltText"},{"tridionKey":"createAccount.informationcenter","linkURL":"createAccount.infoLink","target":"_blank","altText":"createAccount.informationcenterAltText"}]',
    },
    dashboard: {
      isNavigate: false,
      matchIconByUrl: false,
      showBuyTicketsLink: false,
      showDiningReservationLink: false,
      showLinkTicketsLink: false,
      showLinkTicketType: false,
      showTicketContent: false,
      showTicketDetailsCta: false,
    },
    deletingUSHAccount: false,
    displayFirstNameFirst: false,
    isV1_1FeatureEnabled: false,
    profileTPMDetails: {
      otherMembers: false,
    },
    showContentCallout: false,
    showEntitlementsInfo: false,
    showReEnterPassword: false,
    showShareQr: false,
    viewEntitlements: false,
  },
  contentApiBaseUrl: '',
  gds_footer: {
    content_id: '',
  },
  tridion: {
    publication: '',
  },
  contentIds: {
    GDS_GLOBAL_NAV_MEGA_NAV_CONTENT_ID: '',
    GDS_GLOBAL_NAV_UTILITY_BAR_CONTENT_ID: '',
  },
  contentIdTokenUrl: '/oidc/connect/token',
  contentLoginClientID: '',
  contentLoginClientKeyID: '',
  contentOidcTokenApi: false,
  cookieSubDomain: '',
  coveo: {
    accessKeyID: 'xxf6d142fb-2bea-4a24-9123-26d2cccb0163',
    crossOrigin: 'anonymous',
    css: 'https://static.cloud.coveo.com/searchui/v2.10094/3/css/CoveoFullSearch.min.css',
    cssHash:
      'sha512-TBs03XI7M4g24z1tWm/81JbvLmC37V35QJxFCayy4NH0yDZ46d/zYlgO9QxLPBu2DmKEsKQxtqfgOU/GfvIRwA==',
    enabled: true,
    organizationId: 'nbcuniversalnonproduction10wz5488n',
    scriptLocale:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/cultures/es-es.js',
    scriptLocaleHash:
      'sha512-qFjeMB7hdq+a25Bedf+7iUMML1MhsfdSdng2Te69YmR/et5iIxZlK381Wey234INGujG1xN0oGLo4LdzX5A/7g==',
    scriptSearchHash:
      'sha512-0TQxte3BQBFm6LMBjWvy7BSL3OfnzWeZan5bGVd2B/If/9wIYL7ipAWDRtI8HsM08TwP0c6DYnhfy9cOGe56hg==',
    scriptSearchUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/CoveoJsSearch.Lazy.min.js',
    scriptTemplateHash:
      'sha512-eiSn4qRsVzoRB0c52nRdn8mWn04bANr/LV3rXslk9b+PLN73I6aod28OyEbPTn7iMETKQHlSPESNdosKL/Cp8w==',
    scriptTemplateUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/templates/templates.j',
  },
  crewToolsApi: '',
  defaultCountry: 'us',
  defaultCurrency: 'USD',
  defaultLanguage: 'en',
  defaultTheme: 'assets/_themes.css',
  deleteAccountConfirmationFlow: false,
  deleteRedirectURL: '',
  denaliUrl: 'https://tickets2.universalorlando.com',
  digitalDataAdblockerEnabled: false,
  digitalDataAngularVersion: '8.3',
  digitalDataAppVersion: '1.0',
  digitalDataDestination: 'UO',
  digitalDataEnabled: true,
  digitalDataEnvironment: '',
  digitalDataFlashVersion: '',
  digitalDataSegment: 'B2C',
  digitalDataSite: '',
  digitalDataTridionVersion: 'site9',
  diningReservationsAppPath: '',
  displayDateByTimezone: false,
  entitlementBaseUrl: '',
  entitlementDataUrl: '',
  facebookLikeUrl: 'https://www.facebook.com/UniversalOrlandoResort/',
  faviconUrl: '',
  fetchTravelPartyUrl: '',
  fontCssUrl: 'assets/fonts/_fonts.css',
  geo: {
    apiUrl: '/api/geo/location',
    disabled: false,
    location: {
      akamai: false,
    },
    region: {
      primary: '',
    },
    service:
      'https://geo-location-prod.use.ucdp.net/GeoDirectoryServer-7.2.0/v1/ipinfo/',
  },
  getTicketsLink: '',
  globalNavigationEnabled: true,
  googleCalendarApiKey: '',
  googleSiteVerificationKey: 'ammiNOphmIzZZZCvL2SUchOTkKnjM1ydny4KqL_ERW4',
  grecaptchaApiUrl: '//www.google.com/recaptcha/api.js',
  grecaptchaEnabled: false,
  grecaptchaSiteKey: '6LfEHyYTAAAAAGZu9fnOAAkhJhB5_Ylz6VNNMQZe',
  grecaptchaTestResponse: 'bc1f106a-adb7-45e8-b314-0a61febd5555',
  gtmId: 'GTM-5JHWPZQQ',
  hideScanIconDesktop: false,
  hmacKey: '',
  iconCssUrl: 'assets/icons/_font-face.css',
  inquiryToken: '',
  isMMDDYYYYFormat: false,
  isRToasterTagEnabled: false,
  layoutHeader: '_LayoutHeader.html',
  linkEntitlement: '/guests/{guest-id}/link-entitlements',
  mobileServicesApi: {
    baseUrl: 'https://servicesstg.universalorlando.com/api',
    key: 'TestingClient',
    token: '0DDA1406-3835-4953-9DE0-00001F3E98E8',
    city: 'Hollywood',
    cityCode: '',
    venueEndpoint: '/Venues',
    showTimesEndpoint: '/api/PointsOfInterest/Shows/ShowTimes',
  },
  oauthAppFlowPath: '/guestauth/app/token',
  oauthAppPasswordFlowPath: '/guestauth/user/token',
  oauthAppSourceId: '1002062',
  oauthBaseUrl: '',
  oauthClientKeyID: '',
  oidc: {
    app_flow_path: '/oidc/connect/token',
    enabled: true,
    end_session: '/oidc/connect/endsession',
    node_api_base_url: '/account/api/oidc',
    password_flow_path: '/oidc/connect/token',
    redirect_enabled: true,
    redirect_url: '/oidc/connect/authorize',
    refresh_expires_in_seconds: 86400,
  },
  oidcInquiryClientId: '',
  oidcInquiryClientKeyID: '',
  oneTrustCrossorigin: 'anonymous',
  oneTrustDomainScript: '',
  oneTrustEnabled: false,
  oneTrustHash: '',
  oneTrustModalScript: '',
  oneTrustPrivacyGeo: 'US',
  oneTrustPrivacyIds: 'dummy',
  oneTrustPrivacyLSPA: 'false',
  oneTrustPrivacyScript: '',
  pageLabels: 'accounts',
  pageLabelsUrl: '',
  parkInfo: {
    abbreviatedMonthDayYearFormat: 'MMM dd, yyyy',
    MonthDayYearFormat: 'MM/dd/yyyy',
    MonthDayYearWithWeekday: 'MMM dd, yyyy (EEE)',
    TimeZone: 'America/Los_Angeles',
  },
  qrCodeAPIParam: 'textToEncode',
  qrCodeAPIUrl: '/webdata/CodeGenerator/QRCodeGen/?factor=8',
  qrCodeDomainUrl: 'https://www.universalorlando.com',
  resortAreaCode: 'UHULV',
  resortName: 'UHULV',
  rToasterTagId: '',
  sap_cart: {
    commerce_client_id: 'mobile_android',
    commerce_client_secret_id: 'secret',
    commerce_client_creds: 'client_credentials',
    is_cart_enabled: true,
    occ_base_url: '',
    base_site: '',
  },
  sendParamsTravelParty: false,
  seoDescription:
    'The various areas with different expressions are a different world full of excitement. A theme park with world-class entertainment that can be enjoyed by both children and adults, including exciting rides themed after Hollywood blockbusters and shows starring popular characters.',
  seoFacebookSiteName: 'Universal Orlando Resort',
  seoImage:
    'https://www.universalorlando.com/tridiondata/k2/en/us/files/Images/universal-orlando-resort-color-logo-b.png',
  seoTitle: '',
  seoTwitterSiteName: '@UniversalORL',
  shareQrCodeUrl: '/guest/entitlements/{guestId}/{mediaId}',
  shareQrEntitlementsAvailable: false,
  showAlphanumericLinkError: false,
  showCommPrefCard: false,
  showCreditCardDetails: false,
  showCreditCardExpDate: false,
  showdeliveryCost: false,
  showEdit: false,
  showGalaxyTickets: false,
  showICELinkInCoupon: false,
  showLogoutCard: false,
  showPasswordCard: false,
  showPaymentCard: false,
  showPhoneCard: false,
  showProfileBirthday: false,
  showProfileGender: false,
  showProfileUpdates: false,
  showTax: false,
  showTaxLabel: false,
  siteName: 'NV',
  sorryPagePath: '/oops-sorry',
  SourceIdKey: {
    en: {
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1042004',
      WebPaymentCard: '1032007',
      WebAccountCreation: '1042002',
      WebCreateorEditProfileTravelParty: '1042003',
      WebEditAddress: '1032007',
      WebEditCommunications: '1032004',
      WebEditContactInfo: '1032005',
      WebEditPersonalInfo: '1042002',
      WebLinkEntitlements: '1032017',
    },
    ja: {
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1042004',
      WebPaymentCard: '1032007',
      WebAccountCreation: '1042002',
      WebCreateorEditProfileTravelParty: '1042003',
      WebEditAddress: '1032007',
      WebEditCommunications: '1032004',
      WebEditContactInfo: '1032005',
      WebEditPersonalInfo: '1042002',
      WebLinkEntitlements: '1032017',
    },
  },
  specialOffers: false,
  subTotalTaxIncluded: false,
  taxCodes: {
    display: false,
    NV_LIVE_ENT: '',
    SALES_TAX: '',
  },
  timeZone: 'America/New_York',
  tridionBaseUrl: '/tridiondata',
  tridionSite: 'uhulv',
  tripDetailLink: '/web-packages/en/us/shopping-cart/{requestId}',
  uniWebServiceApiKey: 'WebApp',
  uprvUrl:
    'https://res.alpha.universalorlandovacations.com/Booking/Retrieval/Default.aspx?confirmationNo=Reservation_ID&id_token_hint=token_id',
  upsellPackages: 'H572, H573',
  wcsStoreId: '10851',
  weatherApi: '',
  webAppPath: '',
  webstoreAppPath: '',
  webstoreJunction: '',
  wtsHostBaseUrl: '',
};

// export const environment = merge(shared_environment, udeploy);
// export const environment = shared_environment;
